import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LeaderboardAllDto } from '../../../models/dtos/leaderboardAll.dto';
import { Errors } from '../../errors';
import getLeaderboardAllTeamsRequest from './getLeaderboardAllTeams.repository';

type InitialState = {
  loading: boolean;
  data?: LeaderboardAllDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getLeaderboardAllTeams = createAsyncThunk(
  'getLeaderboardAllTeams',
  async () => {
    return await getLeaderboardAllTeamsRequest();
  }
);

const getLeaderboardAllTeamsSlice = createSlice({
  name: 'getLeaderboardAllTeams',
  initialState,
  reducers: {
    getLeaderboardAllTeamsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLeaderboardAllTeams.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getLeaderboardAllTeams.fulfilled,
      (state, action: PayloadAction<LeaderboardAllDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getLeaderboardAllTeams.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getLeaderboardAllTeamsSlice.reducer;
export const { getLeaderboardAllTeamsReset } = getLeaderboardAllTeamsSlice.actions;
